<template>
  <f7-page data-tour-id="samples-register-templates-list-page">
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader />
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>

    <div v-if="loaded">
      <div
        class="custom-table-container tableContainer"
        data-tour-id="samples-register-templates-list-container"
      >
        <TemplatesList
          ref="templatesList"
          :key="templatesListKey"
          :filters="initialFilters"
          @select-template="onSelectTemplate"
        />
      </div>
    </div>
  </f7-page>
</template>

<script>
import TemplatesList from '@/components/TemplatesManager/TemplatesList/index.vue';
import {
  NOTIFY_TIME_LONG,
  SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY,
} from '@/js/constants';
import { mapActions, mapState } from 'vuex';
import {
  consumePendingSamplesRegisterTemplatesListTourStart,
  startSamplesRegisterTemplatesListGuidedTour,
  stopSamplesRegisterGuidedTour,
} from '@/services/samplesRegisterGuidedTour';

export default {
  name: 'TemplatesListPage',
  components: {
    TemplatesList,
  },
  data() {
    return {
      loaded: false,
      templatesListKey: 0,
      guidedTourStartTimeoutId: null,
    };
  },
  computed: {
    ...mapState('contact', ['company']),
    initialFilters() {
      return {
        active: undefined,
      };
    },
  },
  watch: {
    loaded(value) {
      if (value) {
        this.scheduleSamplesGuidedTourStart();
      }
    },
    company(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.resetData();
        this.templatesListKey += 1;
      }
    },
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name:
          this.$t('TemplatesListTitle') !== 'TemplatesListTitle'
            ? this.$t('TemplatesListTitle')
            : 'Plantillas de muestreo',
        disabled: false,
        page: 'TemplatesListPage',
        active: true,
      },
    ]);
  },
  async mounted() {
    try {
      this.loaded = false;
    } finally {
      this.loaded = true;
      this.scheduleSamplesGuidedTourStart();
    }
  },
  beforeDestroy() {
    this.clearSamplesGuidedTourStartTimeout();
    stopSamplesRegisterGuidedTour(this);
  },
  methods: {
    clearSamplesGuidedTourStartTimeout() {
      if (this.guidedTourStartTimeoutId) {
        clearTimeout(this.guidedTourStartTimeoutId);
        this.guidedTourStartTimeoutId = null;
      }
    },
    scheduleSamplesGuidedTourStart({ force = false } = {}) {
      if (!this.loaded) return;
      const shouldContinueFromTemplateCreate =
        force ||
        consumePendingSamplesRegisterTemplatesListTourStart();
      if (!shouldContinueFromTemplateCreate) {
        return;
      }

      this.clearSamplesGuidedTourStartTimeout();
      this.guidedTourStartTimeoutId = setTimeout(() => {
        this.guidedTourStartTimeoutId = null;
        startSamplesRegisterTemplatesListGuidedTour(this, {
          force: true,
        });
      }, SAMPLES_REGISTER_GUIDED_TOUR_AUTO_START_DELAY);
    },
    async openTourTemplateDetails() {
      return (
        (await this.$refs.templatesList?.openTourTemplateDetails?.()) || {
          opened: false,
        }
      );
    },
    openTourSamplesRegister() {
      this.$f7router.navigate(
        {
          name: 'SamplesRegister',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
      return true;
    },
    async onSelectTemplate(template) {
      const templateId =
        template?.template?.id || template?.id || null;

      if (!templateId) return;

      try {
        this.$f7.preloader.show();
        await this.fetchTemplate(templateId);
        this.$f7router.navigate(
          {
            name: 'TemplateDetailsPage',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('samplingTemplatesModule', [
      'fetchTemplate',
      'resetData',
    ]),
  },
};
</script>
